document.addEventListener('DOMContentLoaded', () => {
  let menuItems = document.querySelectorAll('.cst_main_menu li');

  menuItems.forEach(item => {
    item.addEventListener('click', () => {

      // If clicked item is already active → remove active and stop
      if (item.classList.contains('active')) {
        item.classList.remove('active');
        return;
      }

      // Otherwise remove active from all
      menuItems.forEach(li => li.classList.remove('active'));

      // And activate clicked item
      item.classList.add('active');
    });
  });
  let mobileList = document.querySelectorAll('.mobile_menu .main_menu_list_links');
  if(mobileList.length > 0){
    mobileList.forEach(li =>{
      li.addEventListener('click',()=>{
        li.classList.toggle('active')
        li.nextElementSibling.classList.toggle('active')
      })
    })
  }
  let btnMobile = document.querySelector('.mobile_menu .cst_btn_more');
  if(btnMobile){
    btnMobile.addEventListener('click',()=>{
      btnMobile.classList.toggle('active');
      let btnMenu = btnMobile.querySelector('.right_side_menu');
      if(btnMenu){
        btnMenu.classList.toggle('active');
      }
    })
  }
  let closeBtn = document.querySelector('.menu_drawer_close');
  if(closeBtn){
    closeBtn.addEventListener('click',()=>{
      let menu = document.querySelector('.mobile_menu');
      if(menu){
        menu.classList.remove('active');
      }
    })
  }
  let open = document.querySelector('.mobile_menu_open_icon');
    
    if( open ){
      open.addEventListener('click',()=>{
        let menu = document.querySelector('.mobile_menu');
        if(menu){
          menu.classList.add('active');
        }
      })
  }
  
});

let rad = document.querySelectorAll('.flex input');
let btn = document.querySelector('.personalize_wrapper');
rad.forEach(rad =>{
  rad.addEventListener('change',()=>{
    let frmBtn = document.querySelector('.product-form__buttons');
    if(frmBtn && frmBtn.classList.contains('show') && (rad.value == 'yes' || rad.value== 'Yes' || rad.value == 'YES')){
    
      frmBtn.classList.remove('show');
      btn.classList.add('show');
    }else{
      frmBtn.classList.add('show');
      if(btn.classList.contains('show')){
      btn.classList.remove('show');
      }
    }
  })
})
